import React, {useEffect, useState} from "react";

import MenuAlto from './menuAlto'
import Intestazione from './intestazione'
import FondoPagina from './fondoPagina'

import ios26_1 from './immagini/ios26-1.png';
import ios26_2 from './immagini/ios26-2.png';
import ios26_3 from './immagini/ios26-3.png';
import ios26_4 from './immagini/ios26-4.png';
import ios26_5 from './immagini/ios26-5.png';
import iphoneCondividi from './immagini/iphoneCondividi.png';
import iphoneEsportaSchermataHome from './immagini/iphoneEsportaSchermataHome.png';
import iphoneAggiungiHome from './immagini/iphoneAggiungiHome.png';
import androidCondividi from './immagini/androidCondividi.png';

import './App.css';

function ScaricaApp(props) {
    const PAGINA_DEFAULT = 0;
    const PAGINA_SPIEGAZIONE_ICONA_SCELTA_DISPOSITIVO = 1;
    const PAGINA_SPIEGAZIONE_ICONA_ANDROID = 2;
    const PAGINA_SPIEGAZIONE_ICONA_IOS = 3;
    const [pagina, setPagina] = useState(PAGINA_DEFAULT);

    function Nota(props) {
        return (<sup><span style={{fontSize:11}}>({props.numero})</span></sup>);
    }

    return (
        <div className='App'>     
            <MenuAlto {...props} bottoneHome={true}/>
            <Intestazione {...props} titoloPagina="APP"/>

            <div 
                style={{
                    minHeight:props.altezzaContenitoreHome,
                    backgroundColor: "#F5F5F5",
                    marginTop: 20,
                    marginBottom: 40,
                    marginLeft: 20,
                    marginRight: 20,
                    paddingTop: 10,
                    paddingBottom: 10,
                    paddingLeft: 10,
                    paddingRight: 10,
                    alignItems: "center",
                    display:"flex",
                    flexDirection: "column",
                    fontSize:16,
                    lineHeight:1.4                
                }}
            >

                {pagina===PAGINA_DEFAULT && <>
                    Il software è a disposizione gratuitamente per tutti gli iscritti alle Società che utilizzano Gestione Sportiva!
                    <br/><br/>
                    <div style={{fontSize:20, color:"#FF0000", fontWeight:'bold'}}>Installare la APP è semplice:</div>
                    <div style={{fontSize:20, color:"#FF0000", fontWeight:'bold'}}>
                    prendi il telefono, vai su gestionesportiva.it e clicca sul bottone ACCEDI.
                    </div>
                    <br/>
                    Prima di chiederti email e password, comparirà la spiegazione per installare Gestione Sportiva nel tuo telefono,<br/>troverai l'icona che userai per accedere alla APP dopo il primo accesso (dovrai inserire la password una sola volta).<br/><br/>
                    Vuoi conoscere ora la procedura per installare la APP? Clicca qui:
                    <div className="bottone" onClick={() => setPagina(PAGINA_SPIEGAZIONE_ICONA_SCELTA_DISPOSITIVO)}>Come si installa la APP creando l'icona nel telefono?</div>
                </>}

                {pagina===PAGINA_SPIEGAZIONE_ICONA_SCELTA_DISPOSITIVO && <>
                    Che telefono hai?
                    <div style={{display:'flex', flexDirection: 'row'}}>
                    <div style={{flex:1, whiteSpace: "nowrap"}} className="bottone" onClick={() => setPagina(PAGINA_SPIEGAZIONE_ICONA_ANDROID)}>Android</div>
                    <div style={{flex:1, whiteSpace: "nowrap", marginLeft:"10px"}} className="bottone" onClick={() => setPagina(PAGINA_SPIEGAZIONE_ICONA_IOS)}>iPhone o iPad</div>                    
                    </div>
                </>}

                {pagina === PAGINA_SPIEGAZIONE_ICONA_IOS && <>
                    <div style={{fontSize:20, color:"#FF0000", fontWeight:'bold'}}>Installazione APP per IPHONE E IPAD AGGIORNATI (da iOS 26)</div>
                    <div style={{marginTop:20, textAlign:'left', border: "1px solid #C0C0C0", borderRadius:20, padding:20}}>
                        1. Apri Safari, che normalmente usi per navigare
                        <br/><br/>
                        2. Vai sul sito gestionesportiva.it e <span style={{color:"#FF0000", fontWeight:'bold'}}>clicca ACCEDI</span> (non passare al passaggio seguente prima di aver cliccato Accedi)
                        <br/><br/>
                        3. Clicca sui tre puntini, che trovi vicino alla barra degli indirizzi:<br/>
                        <img style={{border: "1px solid #D0D0D0", maxWidth:"80%", maxHeight:"100px", height:"auto"}} src={ios26_1} alt="icona tre puntini"/>
                        <br/><br/>
                        4. Compare un menu, clicca sulla voce "Condividi":<br/>
                        <img style={{border: "1px solid #D0D0D0", maxWidth:"80%", maxHeight:"200px", height:"auto"}} src={ios26_2} alt="icona tre puntini"/>
                        <br/><br/>
                        5. Compare una finestra, clicca sul bottone "Altro" con i 3 puntini:<br/>
                        <img style={{border: "1px solid #D0D0D0", maxWidth:"80%", maxHeight:"200px", height:"auto"}} src={ios26_3} alt="icona tre puntini"/>
                        <br/><br/>
                        6. Compare un menu, clicca sulla voce "Aggiungi alla schermata Home":<br/>
                        <img style={{border: "1px solid #D0D0D0", maxWidth:"80%", maxHeight:"200px", height:"auto"}} src={ios26_4} alt="icona tre puntini"/>
                        <br/><br/>
                        7. Compare la finestra finale, clicca sul bottone Aggiungi:<br/>
                        <img style={{border: "1px solid #D0D0D0", maxWidth:"80%", maxHeight:"200px", height:"auto"}} src={ios26_5} alt="icona tre puntini"/>
                        <br/><br/>
                        Poi chiudi Safari e apri sempre l'applicazione cliccando sull'icona, come fai per le altre APP.
                    </div>
                    <br/><br/>
                    <div style={{fontSize:20, color:"#FF0000", fontWeight:'bold'}}>Installazione APP per IPHONE E IPAD NON AGGIORNATI (prima di iOS 26)</div>
                    <div style={{marginTop:20, textAlign:'left', border: "1px solid #C0C0C0", borderRadius:20, padding:20}}>
                        1. Apri Safari, che normalmente usi per navigare
                        <br/><br/>
                        2. Vai sul sito gestionesportiva.it e <span style={{color:"#FF0000", fontWeight:'bold'}}>clicca ACCEDI</span> (non passare al passaggio seguente prima di aver cliccato Accedi)
                        <br/><br/>
                        3. Clicca su questa icona, che trovi vicino alla barra degli indirizzi:<br/>
                        <img style={{border: "1px solid #D0D0D0", maxWidth:"80%", maxHeight:"50px", height:"auto"}} src={iphoneCondividi} alt="icona condividi"/>
                        <br/><br/>                
                        4. Clicca su "Aggiungi alla schermata Home":<br/>
                        <img style={{border: "1px solid #D0D0D0", maxHeight:"40px",maxWidth:"80%", height:"auto"}} src={iphoneEsportaSchermataHome} alt="aggiungi alla schermata home"/>
                        <br/><br/>            
                        5. Clicca sulla scritta "Aggiungi":<br/>
                        <img style={{border: "1px solid #D0D0D0", maxHeight:"150px",maxWidth:"80%", height:"auto"}} src={iphoneAggiungiHome} alt="aggiungi alla schermata home"/>
                        <br/><br/>        
                        Poi chiudi Safari e apri sempre l'applicazione cliccando sull'icona, come fai per le altre APP.
                    </div>
                    <div className="bottone" onClick={() => setPagina(PAGINA_DEFAULT)}>OK</div>            
                </>}
                
                {pagina === PAGINA_SPIEGAZIONE_ICONA_ANDROID && <>
                    <div style={{fontSize:20, color:"#FF0000", fontWeight:'bold'}}>Installazione APP per ANDROID in 5 passi</div>
                    <div style={{marginTop:20, textAlign:'left', border: "1px solid #C0C0C0", borderRadius:20, padding:20}}>
                        1. Apri il browser Chrome, che normalmente usi per navigare: consigliamo di utilizzare questo browser, anche se il telefono avesse inizialmente un browser diverso
                        <br/><br/>
                        2. Vai sul sito gestionesportiva.it e <span style={{color:"#FF0000", fontWeight:'bold'}}>clicca ACCEDI</span> (non passare al passaggio seguente prima di aver cliccato Accedi)
                        <br/><br/>
                        3. Clicca sui tre puntini, che trovi vicino alla barra degli indirizzi:<br/>
                        <img style={{border: "1px solid #D0D0D0", maxWidth:"80%", maxHeight:"50px", height:"auto"}} src={androidCondividi} alt="icona condividi"/>
                        <br/><br/>
                        4. Clicca su "Aggiungi a schermata Home"
                        <br/><br/>
                        5. Clicca sulla scritta "Installa"
                        <br/><br/>
                        Poi chiudi Chrome e apri sempre l'applicazione cliccando sull'icona, come fai per le altre APP.
                    </div>
                    <div className="bottone" onClick={() => setPagina(PAGINA_DEFAULT)}>OK</div>
                </>}
                    
            </div>

            <FondoPagina {...props}/>
        </div>
    )        
}

export default ScaricaApp;